module.exports = __webpack_public_path__ + "2acb60f2/img/note-list-icon.961c1485.svg";